// import React, { useEffect } from "react";
// import { Box, Typography } from "@mui/material";
// import logo from "../../../../../assets/images/logo.svg";
// import check from "../../../../assets/images/check.svg";
// import ButtonComp from "../../../../components/Button";
// import { string } from "../../../../constants/string";

// export default function CaseSubmission({onHomeClick}:any) {

//   return (
//     <Box
//       display="flex"
//       flexDirection="column"
//       alignItems="center"
//       justifyContent="center"
//       textAlign="center"
//       px={2}
//       bgcolor="#ffffff"
//       height="100vh"
//     >
//       <Box>
//         <img
//           src={check}
//           alt="Logo"
//           style={{ height: 200, width: 200, objectFit: "contain" }}
//         />
//       </Box>

//       <Typography fontSize={38} fontWeight={600} gutterBottom>
//         {string.case.heading}
//       </Typography>

//       <Typography fontSize={30} fontWeight={500} maxWidth={900} mb={4}>
//         {string.case.para}
//       </Typography>

//       <ButtonComp
//         height={40}
//         width={200}
//         variant="contained"
//         onClick={onHomeClick}
//       >
//         {string.case.home}
//       </ButtonComp>
//     </Box>
//   );
// }

import { string } from "../../../../constants/string";
import SubmissionSuccess from "../../components/forms/SubmissionSuccess";

export default function CaseSubmission({heading, para, onHomeClick}:any){

  return(

  <SubmissionSuccess
  heading={heading}
  para={para}
  onHomeClick={onHomeClick}
/>
  )

}



